import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import { useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { fetchUserDetails } from "../../Redux/ReduxSlices/profileSlice";

function PaymentSuccess() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const plan = searchParams.get("plan");
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchUserDetails());
  }, [dispatch]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     navigate("/campaigns");
  //   }, 1000);

  //   // Cleanup timeout on unmount
  //   return () => clearTimeout(timer);
  // }, [navigate]);

  return (
    <div className="min-h-screen bg-white px-4 sm:px-6 lg:px-8">
      <Header />
      <div className="max-w-7xl mx-auto py-8">
        <div className="max-w-3xl mx-auto text-center">
          <FaCheckCircle className=" max-md:h-12 h-16 w-16 text-green-500 mx-auto mb-6" />

          <h1 className="text-3xl max-md:text-xl font-bold text-black mb-4">
            Your Payment Is Successful!
          </h1>

          <p className="text-gray-600 mb-8 max-md:text-sm">
            Thank you for your purchase. Your {plan || "subscription"} has been
            successfully activated.
          </p>
          {/* Added: Instructions for starting campaign */}
          <div className="bg-blue-50 p-6 rounded-lg mb-8 border border-blue-200">
            <h2 className="text-lg max-md:text-xl font-semibold text-blue-800 mb-4">
              How to Start Sending Mails
            </h2>
            <div className="text-left text-gray-700 space-y-4 max-md:text-sm">
              <p className="font-medium text-blue-900">
                Follow these steps to launch your campaign:
              </p>
              <ul className="space-y-3 list-disc list-inside">
                <li className="flex items-start">
                  <span className="font-medium">Go to your</span>
                  <button
                    // onClick={() => navigate("/campaigns")}
                    className="mx-1 text-blue-600 font-semibold underline hover:text-blue-800"
                  >
                    Campaigns Page
                  </button>
                </li>
                <li className="flex items-start">
                  Click on the campaign you want to start sending mails to
                </li>
                <li className="flex items-start">
                  <p>
                    On the campaign details page, click the
                    <span className="mx-1 font-semibold text-green-700">
                      "Resume Campaign"
                    </span>
                    button located on the top right side
                  </p>
                </li>
              </ul>
              <div className="mt-4 pt-3 border-t border-blue-200 flex justify-center items-center">
                <button
                  onClick={() => navigate("/campaigns")}
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  Go to Campaigns →
                </button>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg mb-8">
            <h2 className="text-lg font-semibold text-black mb-4">
              What happens next?
            </h2>
            <ul className="text-left max-md:text-sm text-gray-600 space-y-2">
              <li className="flex items-start">
                <span className="text-green-500 mr-2">•</span>
                Your account has been upgraded with the new features
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">•</span>
                You'll receive a confirmation email shortly
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">•</span>
                Your credits have been added to your account
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="py-12">
        <Footer />
      </div>
    </div>
  );
}

export default PaymentSuccess;
